import React, { useState, useEffect } from "react";
import { fetchDrinks } from "../services/api";

const Welcome = () => {
  // 初期状態の状態管理
  const [drinks, setDrinks] = useState([]); // const [param1, param2] = useState(initValue) 
  const [start, setStart] = useState(0);   
  const num = reactNum; // 一度に取得するお酒の数
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  // useEffect: 初回レンダリング時とページング時に動作
  useEffect(() => {
    const loadDrinks = async () => {
      try {
        const data = await fetchDrinks(lang, num, start); // APIコール
        setDrinks(data); // データを状態にセット
      } catch (error) {
        console.error("Error loading drinks:", error);
      }
    };
  
    loadDrinks(); //最新の感想5個取得するAPIをCALL
  }, [start]);

  // 次のページ
  const handleNext = () => {
    setStart(prevStart => prevStart + num);
  };

  // 前のページ
  const handlePrev = () => {
    if (start >= num) {
      setStart(prevStart => prevStart - num);
    }
  };

  const styles = {
    latest_impression: {
      float: "left",
      paddingTop: "5px",
      paddingBottom: "5px",
      paddingLeft: "10px",
      paddingRight: "10px",
      fontSize: "10px",
    },
    pagination: {
      clear: "both",
      fontSize: "12px",
      paddingBottom: "5px",
    },
    latest_impression_title: {
      paddingTop: "5px",
      paddingBottom: "0px",
    }
  };

  return (
    <div>
      <p style={styles.latest_impression_title}>-- {reactTitle} --</p>
    {drinks.map((drink) => (
      <div style={styles.latest_impression} key={drink.drink_id}>
        <a href={drink.link} data-turbolinks="false">
          <img src={drink.image} alt={drink.drink_name} width="80px" height="120px" />
          <p>{drink.drink_name.length > 10 ? drink.drink_name.substring(0, 10) + "..." : drink.drink_name}</p>
        </a>
      </div>
    ))}
      <div style={styles.pagination}>
        <button onClick={handlePrev} disabled={start === 0}>{"<<"}</button>
        <button onClick={handleNext}>{">>"}</button>
      </div>
    </div>
  );

};


export default Welcome;
